import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

import { ApiService, ClaimService } from '@app-core/services';
import { ClaimsResponse } from '@app-model/api';
import { UserResponse } from '@app-model/login';
import { IGetClaimsRequest } from '@app-model/request';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import * as ClaimsActions from './claims.actions';
import * as fromRoot from '../reducers';

@Injectable()
export class ClaimsEffects {
  private actions$ = inject(Actions);
  private apiService = inject(ApiService);
  private store = inject<Store<fromRoot.State>>(Store);

  getContracts$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(ClaimsActions.GET_CLAIMS),
      withLatestFrom(this.store.select((state) => state.userState.user)),
      mergeMap(([action, user]: [ClaimsActions.GetClaimsAction, UserResponse]) => {
        const allDealers = JSON.parse(JSON.stringify(user.allDealers));

        if (allDealers?.length === 1) {
          allDealers[0].cmsDealerNumber = user.cmsDealerNumber;
        }

        const request: IGetClaimsRequest = {
          dealerId: user.cmsDealerNumber,
          allDealers,
          searchCriteria: {
            vinCode: action.payload.vin,
            claimNumber: action.payload.claimNumber,
            claimsStatus: '',
            endDate: '',
            repairOrderNo: '',
            startDate: '',
          },
        };

        return this.apiService.getClaims(request).pipe(
          // If successful, dispatch success action with result
          map((response: ClaimsResponse) => ({
            type: ClaimsActions.GET_CLAIMS_SUCCESS,
            payload: {
              claims: response.claimStatusInformations,
              filters: ClaimService.fetchClaimsFilters(response.claimStatusInformations),
            },
          })),
          // If request fails, dispatch failed action
          catchError((payload) => {
            console.error(payload);

            return of({ type: ClaimsActions.CLAIMS_FAILURE, payload });
          })
        );
      })
    )
  );
}
